import type { FrontendWidget } from '../types';
import { CompactHeadlineComponent } from './CompactHeadlineComponent';
import type { CompactHeadlineConfig, CompactHeadlineResolved } from './types';

export const compactHeadlineWidget: FrontendWidget<
  CompactHeadlineConfig,
  CompactHeadlineResolved
> = {
  componentType: 'widgets.compact-headline',
  displayName: 'Compact Headline',
  ComponentA: CompactHeadlineComponent,
  resolveSync: (config) => config,
};
